export const projectRouteNames = [
    'al-salem-cultural-centre',
    'ozujsko',
    'eye-on-the-goal',
    'mercury-fraud',
    'vremenco',
];
